import {
  GET_TRACKER_INFO,
  GET_TRACKER_INFO_ERROR,
} from "../constants/TrackerConstants";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
  },
};
export const getTrackerInfo = () => (dispatch) => {
  Axios.get(`${API_ROOT}/trackers/`, config)
    .then((response) =>
      dispatch({ type: GET_TRACKER_INFO, payload: response.data })
    )
    .catch((error) =>
      dispatch({ type: GET_TRACKER_INFO_ERROR, payload: error })
    );
};
